import { ChangeDetectionStrategy, Component, input, signal, ViewEncapsulation } from '@angular/core';

import type { ThemeColorName } from '@examdojo/styles';
import { TreeChartComponent } from './tree-chart.component';
import type { TreeParams, TreePath, TreePathColors } from './tree.model';

@Component({
  selector: 'dojo-tree',
  standalone: true,
  imports: [TreeChartComponent],
  templateUrl: './tree.component.html',
  styleUrl: './tree.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'block w-full' },
})
export class TreeComponent {
  readonly params = input.required<TreeParams>();
  readonly matchingPaths = input<TreePath[]>([]);
  readonly matchingPathColors = input<TreePathColors[]>([]);
  readonly color = input<ThemeColorName>('sky');

  readonly hoveredPath = signal<TreePath | null>(null);

  onPathHover(path: TreePath | null): void {
    if (this.params().display?.hoverEnabled === false) {
      return;
    }
    this.hoveredPath.set(path);
  }
}
